import React from "react";
import { Modal } from "sprint-common-web";

import { LookupContentItem } from "./LookupContentItem";
import { LookupContentList } from "./LookupContentList";

type LookupContentModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onClick: (item: LookupContentItem) => void;
};

export const LookupContentModal = ({ isOpen, onClick, onClose }: LookupContentModalProps): JSX.Element => {
    return (
        <Modal isOpen={isOpen} headerText="Lookup content" onDismiss={onClose} size="lg" displayCloseButton={true}>
            <LookupContentList onClick={onClick} />
        </Modal>
    );
};
